import * as actionTypes from '../actionTypes/authentication';

const createAction = (type, payload) => ({ type, payload });

export const doLogin = (payload = {}) => createAction(actionTypes.AUTH_LOGIN_REQUESTED, payload);
export const doLoginSuccess = (payload = {}) =>
  createAction(actionTypes.AUTH_LOGIN_SUCCEEDED, payload);
export const doLoginFailure = (payload = {}) =>
  createAction(actionTypes.AUTH_LOGIN_FAILED, payload);

export const doLogout = (payload = {}) => createAction(actionTypes.AUTH_LOGOUT_REQUESTED, payload);
export const doLogoutSuccess = (payload = {}) =>
  createAction(actionTypes.AUTH_LOGOUT_SUCCEEDED, payload);
export const doLogoutFailure = (payload = {}) =>
  createAction(actionTypes.AUTH_LOGOUT_FAILED, payload);

export const doReadProfile = (payload = {}) =>
  createAction(actionTypes.PROFILE_READ_REQUESTED, payload);
export const doReadProfileSuccess = (payload = {}) =>
  createAction(actionTypes.PROFILE_READ_SUCCEEDED, payload);
export const doReadProfileFailure = (payload = {}) =>
  createAction(actionTypes.PROFILE_READ_FAILED, payload);

export const doReadPartners = (payload = {}) =>
  createAction(actionTypes.PARTNERS_READ_REQUESTED, payload);
export const doReadPartnersSuccess = (payload = {}) =>
  createAction(actionTypes.PARTNERS_READ_SUCCEEDED, payload);
export const doReadPartnersFailure = (payload = {}) =>
  createAction(actionTypes.PARTNERS_READ_FAILED, payload);

export const doSelectPartners = (payload = {}) => createAction(actionTypes.SELECT_PARTNER, payload);

export const doSendForgotPasswordOTP = (payload = {}) =>
  createAction(actionTypes.SEND_FORGOT_PASSWORD_OTP_REQUESTED, payload);
export const doSendForgotPasswordOTPSuccess = (payload = {}) =>
  createAction(actionTypes.SEND_FORGOT_PASSWORD_OTP_SUCCEEDED, payload);
export const doSendForgotPasswordOTPFailure = (payload = {}) =>
  createAction(actionTypes.SEND_FORGOT_PASSWORD_OTP_FAILED, payload);

export const doResetPassword = (payload = {}) =>
  createAction(actionTypes.RESET_PASSWORD_REQUESTED, payload);
export const doResetPasswordSuccess = (payload = {}) =>
  createAction(actionTypes.RESET_PASSWORD_SUCCEEDED, payload);
export const doResetPasswordFailure = (payload = {}) =>
  createAction(actionTypes.RESET_PASSWORD_FAILED, payload);
